import * as React from "react";
import { Table } from "antd";
import { TReport6ReportPresentationModel } from "../../../presenter/report/model/Report6ReportPresentationModel";
import { TReport6RiskCriteriaPresentationModel } from "../../../presenter/report/model/Report6RiskCriteriaPresentationModel";

const Report6PreviewRiskCriteriasGrid = ({
  report,
  translate
}: {
  report: TReport6ReportPresentationModel;
  translate: any;
}) => {
  const riskCriterias = report.riskCriterias?.map(
    (riskCriteria: TReport6RiskCriteriaPresentationModel) => {
      return { ...riskCriteria, key: riskCriteria.name };
    }
  );

  const columns = [{ key: "name", dataIndex: "name" }];

  return (
    <Table
      className={"report-6-preview-risk-criterias-grid"}
      columns={columns}
      dataSource={riskCriterias}
      showHeader={false}
      pagination={false}
      bordered={true}
      locale={{
        emptyText: translate(
          "report6_preview_risk_criterias_gid.no_risk_criterias"
        )
      }}
    ></Table>
  );
};

export default Report6PreviewRiskCriteriasGrid;
